import { LitElement, html, css } from 'https://cdn.jsdelivr.net/gh/lit/dist@2/core/lit-core.min.js';

const skioStyles = css`
  :host {
    width: 100%;
    display: block;
  }

  .skio-plan-picker {
    display: flex;
    padding: 0;
    border: 0;
    width: 100%;
    position: relative;
    margin-bottom: 0;
    flex-direction: column;
  }

  .skio-group-wrapper {
    display: flex;
    flex-direction: column;
    position: relative;
    background: white;
    border-radius: 6px;
    margin-bottom: 20px;
  }

  @media(min-width: 720px) {
    .skio-group-wrapper {
      flex-direction: row;
    }
  }

  @media(min-width: 720px) {
    .skio-selection-background {
      width: calc(33.33% - 5px);
      height: calc(100% - 10px);
    }
  }

  .skio-onetime-second {
    order: 2;
  }
  
  .skio-group-container {
    display: none;
  }

  .skio-group-container--available {
    position: relative;
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 2px 7px;
    font-size: 14px;
  }

  .skio-group-input {
    position: absolute;
    width: 0px;
    height: 0px;
    opacity: 0;
  }

  .skio-group-input:focus-visible ~ .skio-group-label {
    outline: 2px #ccc solid;
    outline-offset: 4px;
    border-radius: 5px;
  }

  .skio-group-label {
    display: flex;
    flex-direction: column;
    cursor: pointer;
    width: 100%;
  }

  .skio-group-topline {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    width: 100%;
    padding: 10px 0;
    justify-content: center;
    position: relative;
    z-index: 1;
    /* margin-bottom: 20px; */
    /* border-radius: 6px; */
  }

  .skio-group-container--selected .skio-group-topline {
    color: white;
  }

  .skio-group-container--selected {
    background-color: rgb(108, 81, 69);
    border: 5px solid #FFF;
    transition: background 0.5s ease-in-out;
  }
  
  .skio-radio__container {
    display: none;
    margin-right: 10px;
  }
  
  .skio-radio {
    transition: transform 0.25s cubic-bezier(0.4,0,0.2,1), opacity 0.25s cubic-bezier(0.4,0,0.2,1);
    transform-origin: center;
    transform: scale(0);
    opacity: 0;
  }
  .skio-group-label:hover .skio-radio {
    transform: scale(1);
    opacity: 0.75;
  }
  .skio-group-container--selected .skio-group-label .skio-radio {
    transform: scale(1);
    opacity: 1;
  }
  
  .skio-price {
    margin-left: auto;
    display: none;
  }
  
  .skio-group-content {
    width: auto;
    margin-left: 30px;
    transition: max-height 0.25s cubic-bezier(0.4,0,0.2,1),
                opacity 0.25s cubic-bezier(0.4,0,0.2,1);
    max-height: 38px;
    opacity: 1;
  }
  
  /* Hide frequency if not selected */
  .skio-group-container:not(.skio-group-container--selected) .skio-group-content {
    max-height: 0;
    opacity: 0;
    pointer-events: none;
  }
  
  .skio-group-title {
    text-align: center;
  }
  
  /* .skio-save {
    color: #0fa573;
    border: 1px #0fa573 solid; 
    padding: 0px 8px;
    border-radius: 20px;
  }
   */
  .skio-frequency-wrapper {
    display: flex;
    gap: 20px;
    align-items: center;
    margin-bottom: 20px;
  }

  .skio-frequency {
    max-width: 50vw !important;
    display: flex;
    align-items: center;
    gap: 5px;
    padding: 16px 50px 16px 1.09375VW;
    margin-top: 5px;
    border-radius: 5px;
    background-color: #f7f7f7;
    width: min-content;
    border: 0;
    text-overflow: ellipsis;
    background-image: url("//cdn.shopify.com/s/files/1/2236/0863/t/121/assets/select.svg?v=138018266746075464011637706284"), url("//cdn.shopify.com/s/files/1/2236/0863/t/121/assets/delivery.svg?v=81422712700679217211637705973");
    background-position: right 10px top 50%;
    background-size: 18px;
    background-repeat: no-repeat;
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    font-family: 'Pluto Cond Medium';
    color: #3e332e;
  }

  .skio-frequency.skio-frequency--one {
    background-image: none;
  }
  
  .skio-frequency span {
    text-transform: lowercase;
  }

  .skio-selector {
    width: 100%;
  }

  .skio-selector-title {
    display: block;
    color: #3e332e;
    font-family: "Pluto Cond Medium";
    font-size: 16px;
    text-transform: uppercase;
  }

  .skio-details {
    --text-color: #333;
    --text-color-secondary: #888; 
    
    user-select: none;
    -webkit-user-select: none;
    width: 100%;
    flex: 1;
  }

  .skio-details summary {
    font-size: 0.9em;
    display: flex;
    padding: .5em 0;
    cursor: pointer;
    align-items: center;
    gap: 10px;
    text-decoration: underline;
  }

  @keyframes fadeInDown {
    0% {
      opacity: 0;
      transform: translateY(-15px);
    }
    100% {
      opacity: 1;
      transform: translateY(0px);
    }
  }
  .skio-details[open] > .skio-details--content {
    animation-name: fadeInDown;
    animation-duration: 0.3s;
  }

  .skio-details--content {
    position: absolute;
    z-index: 1020;
    padding: 1em;
    width: fit-content;
    border-radius: 5px;
    background: white;
    box-shadow: 0 0 5px rgb(23 24 24 / 5%), 0 1px 2px rgb(0 0 0 / 7%);
  }

  .skio-details ul {
    margin: 0;
    padding: 0;
  }

  .skio-details ul li {
    display: flex;
    align-items: center;
    gap: .75em;

    margin-bottom: 1em;
  }

  .skio-details .skio-content {
    display: flex;
    flex-direction: column;
  }

  .skio-details .skio-content p {
    font-size: 0.9em;

    margin-top: 0;
    margin-bottom: 0;

    letter-spacing: 0;
    line-height: 1.5;

    color: var(--text-color);
  }

  .skio-details ul li small {
    font-size: 0.8em;
    color: var(--text-color-secondary);
  }

  .skio-details .skio-icon {
    display: flex;

    width: 2.25em;
    height: 2.25em;

    color: var(--text-color);
    background: #f8f8f8;
    border-radius: 100%;

    flex-shrink: 0;
    align-items: center;
    justify-content: center;
  }

  .skio-details .skio-icon svg {
    width: 1.25em;
    height: 1.25em;

    color: inherit;
  }

  .skio-details--footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 0.9em;
  }

  .skio-details--footer a {
    color: var(--text-color);
  }

  .skio-manage-link {
    text-decoration: underline;
  }

  .powered-by-skio {
    font-size: 0.8em;

    display: flex;
    text-decoration: none;
    
    align-items: center;
    gap: 3px;
  }
`;

export class SkioPlanPickerComponent extends LitElement {
  static properties = {
    product: { type: Object },
    productHandle: { type: String },
    selectedVariant: { type: Object },
    key: { type: String },
    formId: { type: String },
    skioSellingPlanGroups: {},
    availableSellingPlanGroups: {},
    selectedSellingPlanGroup: {},
    selectedSellingPlan: {},
    startSubscription: { type: Boolean },
    subscriptionFirst: { type: Boolean },
    subscriptionThird: { type: Boolean },
    discount_format: { type: String },
    ajaxSubmit: { type: Boolean },
    moneyFormatter: {},
    buttonSelector: { type: String }
  };

  static styles = skioStyles;

  constructor() {
    super();
    // Define reactive properties--updating a reactive property causes the component to update.
    this.product = null;
    this.selectedVariant = null;

    this.productHandle = null;

    this.key = null;
    this.formId = null;

    this.skioSellingPlanGroups = null;
    this.availableSellingPlanGroups = null;

    this.selectedSellingPlanGroup = null;
    this.selectedSellingPlan = null;

    this.startSubscription = false;

    this.subscriptionFirst = false;

    this.subscriptionThird = false;

    this.skioMainProduct = true;

    this.discountFormat = 'percent';

    this.ajaxSubmit = false;

    this.buttonSelector = null;

    this.moneyFormatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: window?.Shopify?.currency?.active || 'USD', // Todo potentially remove as headless stores don't have window.Shopify
    });
  }

  connectedCallback() {
    // This is the equivalent to mounted
    super.connectedCallback();
  }

  render() {
    return html`
    ${ this.product && this.selectedVariant && this.availableSellingPlanGroups?.length ? 
      html`
      <fieldset class="skio-plan-picker" skio-plan-picker="${ this.key }" skio-auto-init>
        <input name="selling_plan" type="hidden" value="${ this.selectedSellingPlan !== null ? this.selectedSellingPlan.id : ''}" />
        <input name="properties[Discount]" type="hidden" value="${ this.selectedSellingPlan !== null ? this.discount(this.selectedSellingPlan).percent : '' }" 
          ?disabled="${ this.selectedSellingPlan == null ? true : false }" />

        <div class="skio-group-wrapper skio-plan-selection">
          <div class="skio-group-container ${ this.product.requires_selling_plan == false ? 'skio-group-container--available' : '' } ${ this.selectedSellingPlanGroup == null ? 'skio-group-container--selected' : '' } ${ this.subscriptionFirst ? 'skio-onetime-second' : ''}" skio-group-container 
            @click=${() => this.selectSellingPlanGroup(null) } >
          
            <input id="skio-one-time-${ this.key }" class="skio-group-input" name="skio-group-${ this.key }" type="radio" value="" 
              skio-one-time ?checked=${ this.startSubscription == false && this.product.requires_selling_plan == false ? true : false }>

            <label class="skio-group-label" for="skio-one-time-${ this.key }">
              <div class="skio-group-topline">
                <div class="skio-radio__container">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2"></circle>
                    <circle class="skio-radio" cx="12" cy="12" r="7" fill="currentColor"></circle>
                  </svg>
                </div>
                One-time purchase
                <div class="skio-price">
                  <span skio-onetime-price>${ this.moneyFormatter.format(this.selectedVariant.price / 100) }</span>
                </div>
              </div>
            </label>
          </div>

          
          ${ this.availableSellingPlanGroups ? this.availableSellingPlanGroups.map((group, index) => 
            html`
              <div class="skio-group-container skio-group-container--available ${ this.selectedSellingPlanGroup == group ? 'skio-group-container--selected' : '' }" skio-group-container
                @click=${() => this.selectSellingPlanGroup(group) }>
                <input id="skio-selling-plan-group-${ index }-${ this.key }" class="skio-group-input" name="skio-group-${ this.key }"
                  type="radio" value="${ group.id }" skio-selling-plan-group="${ group.id }" ?checked="${ this.selectedSellingPlanGroup == group ? true : false }">
                <label class="skio-group-label" for="skio-selling-plan-group-${ index }-${ this.key }">
                  <div class="skio-group-topline">
                    <div class="skio-radio__container">
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2"></circle>
                        <circle class="skio-radio" cx="12" cy="12" r="7" fill="currentColor"></circle>
                      </svg>
                    </div>
                    <div class="skio-group-title">
                      ${group.name === 'Subscription' ? 'Subscribe' : group.name}
                      ${ this.discount(group.selected_selling_plan).percent !== '0%' ? html`
                        <span class="skio-save">${group.name === 'Subscription' ? '& save' : ''} (<span skio-discount>${ this.discountFormat == 'percent' ? this.discount(group.selected_selling_plan).percent : this.discount(group.selected_selling_plan).amount }</span> OFF)</span>
                      ` : html`` }
                    </div>
                    <div class="skio-price">
                      <span skio-subscription-price>${ this.price(group.selected_selling_plan) }</span>
                    </div>
                  </div>
                </label>
              </div>
            `
          ): ''}
        </div>

        ${ this.selectedSellingPlanGroup ?
          html`
          <div class="skio-selector">
            <span class="skio-selector-title">Delivery Every</span>

            <div class="skio-frequency-wrapper">
              <select class="skio-frequency"
                @change=${ (e) => this.selectSellingPlan(e.target, this.selectedSellingPlanGroup) }>
                ${ this.selectedSellingPlanGroup ? this.selectedSellingPlanGroup.selling_plans.map((selling_plan) => 
                    html`
                    <option value="${ selling_plan.id }">
                      ${ selling_plan.name.replace('Every', '') }
                    </option>
                    `
                  ): ''}
              </select>
              <details class="skio-details">
                <summary>
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="ai ai-ArrowRepeat"><path d="M18 2l3 3-3 3"/><path d="M6 22l-3-3 3-3"/><path d="M21 5H10a7 7 0 0 0-7 7"/><path d="M3 19h11a7 7 0 0 0 7-7"/></svg>
                  
                  Subscription details
                </summary>

                <div class="skio-details--content">
                  <ul>
                    <li>
                      <div class="skio-icon">
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                          <path stroke-linecap="round" stroke-linejoin="round" d="M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2zm7-5a2 2 0 11-4 0 2 2 0 014 0z" />
                        </svg>
                      </div>

                      <div class="skio-content">
                        <p>Save up to 30%</p>
                      </div>
                    </li>

                    <li>
                      <div class="skio-icon">
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                          <path d="M9 17a2 2 0 11-4 0 2 2 0 014 0zM19 17a2 2 0 11-4 0 2 2 0 014 0z" />
                          <path stroke-linecap="round" stroke-linejoin="round" d="M13 16V6a1 1 0 00-1-1H4a1 1 0 00-1 1v10a1 1 0 001 1h1m8-1a1 1 0 01-1 1H9m4-1V8a1 1 0 011-1h2.586a1 1 0 01.707.293l3.414 3.414a1 1 0 01.293.707V16a1 1 0 01-1 1h-1m-6-1a1 1 0 001 1h1M5 17a2 2 0 104 0m-4 0a2 2 0 114 0m6 0a2 2 0 104 0m-4 0a2 2 0 114 0" />
                        </svg>
                      </div>

                      <div class="skio-content">
                        <p>Free US Shipping on Orders $44+</p>
                      </div>
                    </li>

                    <li>
                      <div class="skio-icon">
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                          <path stroke-linecap="round" stroke-linejoin="round" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                        </svg>
                      </div>
                      
                      <div class="skio-content">
                        <p>Early access to new products</p>
                      </div>
                    </li>
                  </ul>

                  <div class="skio-details--footer">
                    <a class="skio-manage-link" href="/a/account/login">Manage subscriptions</a> 


                    <a style="letter-spacing: 0" class="powered-by-skio" href="https://skio.com/?utm_source={{ shop.name }}&utm_medium=details_popover" target="_blank" rel="noopener">
                      Powered by

                      <svg width="24" height="11" viewBox="0 0 24 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M4.28399 5.78801C4.12399 5.63601 3.93599 5.50801 3.71999 5.40401C3.50399 5.30001 3.27599 5.24801 3.03599 5.24801C2.85199 5.24801 2.67999 5.28401 2.51999 5.35601C2.36799 5.42801 2.29199 5.55201 2.29199 5.72801C2.29199 5.89601 2.37599 6.01601 2.54399 6.08801C2.71999 6.16001 2.99999 6.24001 3.38399 6.32801C3.60799 6.37601 3.83199 6.44401 4.05599 6.53201C4.28799 6.62001 4.49599 6.73601 4.67999 6.88001C4.86399 7.02401 5.01199 7.20001 5.12399 7.40801C5.23599 7.61601 5.29199 7.86401 5.29199 8.15201C5.29199 8.52801 5.21599 8.84801 5.06399 9.11201C4.91199 9.36801 4.71199 9.57601 4.46399 9.73601C4.22399 9.89601 3.95199 10.012 3.64799 10.084C3.34399 10.156 3.03999 10.192 2.73599 10.192C2.24799 10.192 1.76799 10.116 1.29599 9.96401C0.831989 9.80401 0.443989 9.57201 0.131989 9.26801L1.23599 8.10401C1.41199 8.29601 1.62799 8.45601 1.88399 8.58401C2.13999 8.71201 2.41199 8.77601 2.69999 8.77601C2.85999 8.77601 3.01599 8.74001 3.16799 8.66801C3.32799 8.58801 3.40799 8.45201 3.40799 8.26001C3.40799 8.07601 3.31199 7.94001 3.11999 7.85201C2.92799 7.76401 2.62799 7.67201 2.21999 7.57601C2.01199 7.52801 1.80399 7.46401 1.59599 7.38401C1.38799 7.30401 1.19999 7.19601 1.03199 7.06001C0.871989 6.92401 0.739989 6.75601 0.635989 6.55601C0.531989 6.35601 0.479989 6.11601 0.479989 5.83601C0.479989 5.47601 0.555989 5.17201 0.707989 4.92401C0.859989 4.66801 1.05599 4.46001 1.29599 4.30001C1.53599 4.14001 1.79999 4.02401 2.08799 3.95201C2.38399 3.87201 2.67599 3.83201 2.96399 3.83201C3.41199 3.83201 3.84799 3.90401 4.27199 4.04801C4.70399 4.18401 5.06799 4.39201 5.36399 4.67201L4.28399 5.78801Z" fill="black"/>
                        <path d="M12.8481 10H10.4121L8.45615 7.13201H8.42015V10H6.44015V0.928009H8.42015V6.44801H8.45615L10.3641 4.02401H12.7521L10.4481 6.72401L12.8481 10Z" fill="black"/>
                        <path d="M15.7009 2.11601C15.7009 2.26801 15.6689 2.41201 15.6049 2.54801C15.5489 2.67601 15.4689 2.78801 15.3649 2.88401C15.2689 2.98001 15.1489 3.05601 15.0049 3.11201C14.8689 3.16801 14.7249 3.19601 14.5729 3.19601C14.2529 3.19601 13.9849 3.09201 13.7689 2.88401C13.5529 2.66801 13.4449 2.41201 13.4449 2.11601C13.4449 1.97201 13.4729 1.83601 13.5289 1.70801C13.5849 1.57201 13.6649 1.45601 13.7689 1.36001C13.8729 1.26401 13.9929 1.18801 14.1289 1.13201C14.2649 1.06801 14.4129 1.03601 14.5729 1.03601C14.7249 1.03601 14.8689 1.06401 15.0049 1.12001C15.1489 1.17601 15.2689 1.25201 15.3649 1.34801C15.4689 1.44401 15.5489 1.56001 15.6049 1.69601C15.6689 1.82401 15.7009 1.96401 15.7009 2.11601ZM13.5889 10V4.02401H15.5569V10H13.5889Z" fill="black"/>
                        <path d="M23.4516 6.98801C23.4516 7.47601 23.3636 7.92001 23.1876 8.32001C23.0116 8.71201 22.7716 9.04801 22.4676 9.32801C22.1636 9.60001 21.8116 9.81201 21.4116 9.96401C21.0116 10.116 20.5836 10.192 20.1276 10.192C19.6796 10.192 19.2516 10.116 18.8436 9.96401C18.4436 9.81201 18.0916 9.60001 17.7876 9.32801C17.4916 9.04801 17.2556 8.71201 17.0796 8.32001C16.9036 7.92001 16.8156 7.47601 16.8156 6.98801C16.8156 6.50001 16.9036 6.06001 17.0796 5.66801C17.2556 5.27601 17.4916 4.94401 17.7876 4.67201C18.0916 4.40001 18.4436 4.19201 18.8436 4.04801C19.2516 3.90401 19.6796 3.83201 20.1276 3.83201C20.5836 3.83201 21.0116 3.90401 21.4116 4.04801C21.8116 4.19201 22.1636 4.40001 22.4676 4.67201C22.7716 4.94401 23.0116 5.27601 23.1876 5.66801C23.3636 6.06001 23.4516 6.50001 23.4516 6.98801ZM21.5556 6.98801C21.5556 6.79601 21.5236 6.60801 21.4596 6.42401C21.3956 6.24001 21.3036 6.08001 21.1836 5.94401C21.0636 5.80001 20.9156 5.68401 20.7396 5.59601C20.5636 5.50801 20.3596 5.46401 20.1276 5.46401C19.8956 5.46401 19.6916 5.50801 19.5156 5.59601C19.3396 5.68401 19.1916 5.80001 19.0716 5.94401C18.9596 6.08001 18.8716 6.24001 18.8076 6.42401C18.7516 6.60801 18.7236 6.79601 18.7236 6.98801C18.7236 7.18001 18.7516 7.36801 18.8076 7.55201C18.8716 7.73601 18.9636 7.90401 19.0836 8.05601C19.2036 8.20001 19.3516 8.31601 19.5276 8.40401C19.7036 8.49201 19.9076 8.53601 20.1396 8.53601C20.3716 8.53601 20.5756 8.49201 20.7516 8.40401C20.9276 8.31601 21.0756 8.20001 21.1956 8.05601C21.3156 7.90401 21.4036 7.73601 21.4596 7.55201C21.5236 7.36801 21.5556 7.18001 21.5556 6.98801Z" fill="black"/>
                      </svg>
                    </a>
                  </div>
                </div>
              </details>
            </div>
          </div>
          ` 
        : ''}
      </fieldset>`
      : '' }
    `
  }

  updated = (changed) => {
    if(changed.has('product') && this.product) {
      //update key
      this.key = this.product.id;

      //update skioSellingPlanGroups
      this.skioSellingPlanGroups = this.product.selling_plan_groups.filter(
        selling_plan_group => selling_plan_group.app_id === 'SKIO'
      )
    }

    if (changed.has('subscriptionThird') && this.subscriptionThird) {
      console.log('Third sub selected?')
    }

    if(changed.has('selectedVariant') && this.selectedVariant) {
      //update availableSellingPlanGroups based on skioSellingPlanGroups and selectedVariant.id
      this.availableSellingPlanGroups = this.skioSellingPlanGroups.filter(selling_plan_group =>
        selling_plan_group.selling_plans.some(selling_plan =>
          this.selectedVariant.selling_plan_allocations.some(
            selling_plan_allocation => selling_plan_allocation.selling_plan_id === selling_plan.id
          )
        )
      )

      //update selectedSellingPlan value
      if (this.availableSellingPlanGroups.length > 0) {
        //update each group with a default selected_selling_plan
        this.availableSellingPlanGroups.forEach((group => {
          group.selected_selling_plan = group.selling_plans[0];
        }));

        if(this.startSubscription == true || this.product.requires_selling_plan == true) {
          this.selectedSellingPlanGroup = this.availableSellingPlanGroups[0];
          this.selectedSellingPlan = this.availableSellingPlanGroups[0].selling_plans[0];
        }
      }
    }

    if (changed.has('selectedSellingPlan')) {
      //update price of price elements if applicable
      if(this.selectedSellingPlan) {
        document.querySelectorAll(`[skio-price][skio-key="${ this.key }"]`).forEach((el) => {
          el.innerHTML = `<div class="price-item price-item--sale">${ this.price(this.selectedSellingPlan) }</div>`;
        });
      }

      //update display of external content elements
      document.querySelectorAll(`[skio-onetime-content][skio-key="${ this.key }"]`).forEach((el) => {
        this.selectedSellingPlan !== null ? el.style.display = "none" : el.style.removeProperty('display');
      });

      document.querySelectorAll(`[skio-onetime-content][skio-key="${ this.key }"] input`).forEach((el) => {
        this.selectedSellingPlan !== null ? el.disabled = true : el.disabled = false;
      });
      
      document.querySelectorAll(`[skio-subscription-content][skio-key="${ this.key }"]`).forEach((el) => {
        this.selectedSellingPlan == null ? el.style.display = "none" : el.style.removeProperty('display');
      });

      //dispatch CustomEvent to tell that this specific plan picker was updated, and pass the selectedSellingPlan
      const event = new CustomEvent(`skio::update-selling-plan`, { bubbles: true, composed: true, detail: {
        sellingPlan: this.selectedSellingPlan,
        salePrice: this.price(this.selectedSellingPlan),
        regularPrice: this.money(this.selectedVariant.price),
        showSalePrice: this.selectedSellingPlan !== null,
      }});

      this.dispatchEvent(event);

      this.updateForm();
    }
  }
  
  // Update selected selling plan group; called on click of skio-group-container element
  selectSellingPlanGroup(group) {
    if (group == null) {
      this.selectedSellingPlanGroup = null;
      this.selectedSellingPlan = null;
    } else {
      this.selectedSellingPlanGroup = group;
      this.selectedSellingPlan = group.selected_selling_plan;
    }
  }

  // Update selected selling plan; called on change of skio-frequency select element
  selectSellingPlan(element, group) {
    let selling_plan = group.selling_plans.find(x => x.id == element.value);
    if (selling_plan) {
      group.selected_selling_plan = selling_plan;
      this.selectedSellingPlanGroup = group;
      this.selectedSellingPlan = selling_plan;
    }
    else console.log("Error: couldn't find selling plan with id " + element.value + " for variant " + this.selectedVariant.id + " from product " + this.product.id + " : " + this.product.handle);
  }

  // Formats integer value into money value
  money(price) {
    return this.moneyFormatter.format(price / 100.0)
  }

  // Calculates discount based on selling_plan.price_adjustments, returns { percent, amount } of selling plan discount
  discount(selling_plan) {
    if (!selling_plan)
      return { percent: '0%', amount: 0 }
    
    const isPrepaid = selling_plan.name.toLowerCase().includes('prepaid');
    const price_adjustment = selling_plan.price_adjustments[0]
    const discount = { percent: '0%', amount: 0 }
    const price = this.selectedVariant.price;

    if(this.subscriptionDiscountOverride) {
      return { 
        percent: this.subscriptionDiscountOverride + '%', 
        amount:  Math.round((price * this.subscriptionDiscountOverride) / 100.0)
      }
    }
    
    switch (price_adjustment.value_type) {
      case 'percentage':
        discount.percent = `${price_adjustment.value}%`
        discount.amount = Math.round(
          (price * price_adjustment.value) / 100.0
        )
        break
      case 'fixed_amount':
        discount.percent = `${Math.round(
          ((price_adjustment.value * 1.0) / price) * 100.0
        )}%`
        discount.amount = price_adjustment.value
        break
      case 'price':
        discount.percent = `${Math.round(
          (((price - (isPrepaid ? price_adjustment.value / parseFloat(selling_plan.name) : price_adjustment.value) ) * 1.0) /
            price) *
            100.0
        )}%`
        discount.amount = price - (isPrepaid ? price_adjustment.value / parseFloat(selling_plan.name) : price_adjustment.value)
        break
    }
    
    return discount
  }

  // Calculates the variant's price for the given selling plan, returns a formatted money value (if desired)
  price(selling_plan, formatted = true) {
    const compareAt = this.selectedVariant.compare_at_price > this.selectedVariant.price ? this.selectedVariant.compare_at_price : this.selectedVariant.price;
    return formatted
      ? this.money(compareAt - this.discount(selling_plan).amount)
      : compareAt - this.discount(selling_plan).amount
  }

  updateForm() {
    if (this.formId) {
      let form = document.querySelector(`#${this.formId}`);

      if (form) {
        let selling_plan_input = form.querySelector('[name="selling_plan"]');
        if (selling_plan_input) {
          selling_plan_input.value = this.selectedSellingPlan !== null ? this.selectedSellingPlan.id : null;
        } else {
          selling_plan_input = document.createElement('input');
          selling_plan_input.type = "hidden";
          selling_plan_input.name = "selling_plan";
          selling_plan_input.value = this.selectedSellingPlan !== null ? this.selectedSellingPlan.id : null;
          form.append(selling_plan_input);
        }

        let discount_input = form.querySelector('[name="properties[Discount]"]');
        if (discount_input) {
          discount_input.value = this.selectedSellingPlan !== null ? this.discount(this.selectedSellingPlan).percent : null;
          discount_input.disabled = this.selectedSellingPlan !== null ? false : true;
        } else {
          discount_input = document.createElement('input');
          discount_input.type = "hidden";
          discount_input.name = "properties[Discount]";
          discount_input.value = this.selectedSellingPlan !== null ? this.discount(this.selectedSellingPlan).percent : null;
          discount_input.disabled = this.selectedSellingPlan !== null ? false : true;
          form.append(discount_input);
        }
      } else {
        console.log(`Skio error: form ID is ${ this.formId }, but no form with that ID was found.`);
      }
    }
  }
}

customElements.define('skio-plan-picker', SkioPlanPickerComponent);